import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const keyFrames = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
`;

export const Alert = styled.div`
    background: ${({ hasError, theme }) => (hasError ? theme.colors.pastelDanger300 : '#FFFBF2')};
    border-radius: 5px;
    border: 1px solid ${({ hasError, theme }) => (hasError ? '#e82e41' : theme.colors.banana300)};
    box-sizing: border-box;
    color: black;
    display: flex;
    font-size: 13px;
    justify-content: flex-start;
    padding: 8px;
`;

export const Header = styled.h3`
    color: rgb(28, 28, 28);
    font-size: 20px;
    font-weight: 600;
    height: 25px;
    width: 158px;
`;

export const IconWrapper = styled.div`
    animation: ${keyFrames} 2s infinite linear;
    height: 24px;
    position: relative;
    right: 7px;
    width: 24px;
`;

export const DownloadButton = styled.button`
    align-items: center;
    background-color: ${({ disabled, theme }) => (disabled ? theme.colors.neutral100 : theme.colors.primary300)};
    border: ${({ disabled, theme }) => (disabled ? `1px solid ${theme.colors.neutral000}` : 'none')};
    border: none;
    border-radius: 4px;
    color: white !important;
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    display: flex;
    font-size: 16px;
    font-weight: 600;
    height: 28px;
    justify-content: space-around;
    outline: none;
    padding: 0 12px;
    font-size: 12px;
    icon-size: 18px;
    transition: background-color 200ms linear;
    &:hover {
        background-color: ${({ theme }) => theme.colors.primary700};
    }
    &:disabled {
        pointer-events: none;
    }
`;

export const CloseButtonWrapper = styled.div`
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const MessageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 14px;
`;

export const PersonalizationWrapper = styled.div`
    margin-top: 22px;
`;

export const Message = styled.p`
    margin-top: auto;
    margin-bottom: auto;
    line-height: 24px;
`;

export const MessageHeader = styled(Message)`
    font-weight: 700;
`;

export const ErrorMessage = styled(Message)`
    color: ${({ theme }) => theme.colors.danger700};
    padding-left: 14px;
`;

export const FAIcon = styled(FontAwesomeIcon)`
    font-size: 18px;
    margin-top: 2px;
`;

export const CloseIcon = styled(FAIcon)`
    margin: 6px 12px;
`;

export const MessageIcon = styled(FAIcon)`
    color: #EC7100;
    margin-left: 4px;
`;

export const ErrorMessageIcon = styled(FAIcon)`
    color:  ${({ theme }) => theme.colors.danger700};
    margin-left: 4px;
`;
